import Video from "../components/video/Video";

import { connect } from "react-redux";
import { loadStoryByBmmrId } from "../actions/Video";
import {
    loadUserRecommendations,
    loadMoreUserRecommendations,
} from "../actions/Personalization";
import {
    onPlaylistContinuousPlay,
    updateLiveBarByChannelId,
} from "../actions/PageActions";
import UserExperience from "../utils/UserExperience";
import UserRegionInfo from "../utils/UserRegionInfo";
import ChannelSchedule from "../constants/Schedule";
import mergeProps from "./videoMergeProps";
import { updateSelectedTabIndex } from "../actions/PageSetting";

export function mapStateToProps({
    video,
    schedule,
    clientConfig,
    pageSetting,
    personalization,
}) {
    const { currentChannelId = ChannelSchedule.DEFAULT_SCHEDULE_CHANNEL_ID } =
        schedule;
    const regionChannelId = new UserExperience(
        video.channels
    ).getLiveChannelIdFromRegion(UserRegionInfo.getRegion());
    const schedules = schedule.allSchedules[currentChannelId] || [];
    const regionSchedules = schedule.allSchedules[regionChannelId] || [];
    const liveNow = { ...regionSchedules[0], liveChannelId: regionChannelId };

    return {
        ...video,
        ...pageSetting,
        ...personalization,
        liveNow,
        schedule: {
            ...schedule,
            schedules,
            currentChannelId,
        },
        ...clientConfig,
    };
}

export const mapDispatchToProps = {
    onSelectVideo: loadStoryByBmmrId,
    onLoadUserRecommendation: loadUserRecommendations,
    onPlaylistEndReached: loadMoreUserRecommendations,
    changeSelectedTab: updateSelectedTabIndex,
    onPlaylistSelected: loadStoryByBmmrId,
    onPlaylistContinuousPlay,
    updateLiveBarByChannelId,
};

// this needs to be fixed
export const VideoContainer: any = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Video);
